import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IonicModule} from '@ionic/angular';
import {FileProcessingModalComponent} from './file-processing-modal.component';

@NgModule({
  declarations: [FileProcessingModalComponent],
  imports: [CommonModule, IonicModule],
})
export class FileProcessingModalModule {}
